module.exports = __webpack_public_path__ + "img/HQ-Z7030-V1-B-All.42c48069.jpg";